<template>
  <div class="card-body pt-0 edge-to-edge" v-if="$gate.isAdmin()">
    <div id="tabel_facturare_wrapper">
      <div class="table-responsive">
        <table class="table table-bordered table-striped nowrap" role="grid" id="tabel_facturare">
          <thead>
            <tr class="text-uppercase fw-bold">
              <th class="text-center" style="width:32px">
                <div class="form-check form-check-custom form-check-success form-check-solid d-inline-flex">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :checked="selectAllVisibleChecked"
                    @change="onToggleSelectAllVisible($event)"
                  />
                </div>
              </th>
              <th></th>
              <th>Data</th>
              <th>Nr. doc.</th>
              <th>Client</th>
              <th>Valoare</th>
              <th>TVA</th>
              <th>Total</th>
              <th>Stare</th>
              <th>Sold</th>
              <th>Scadenta</th>
              <th>TVA-I</th>
              <th>e-Fact</th>
              <th>Agent</th>
              <th>Reg Jurnal</th>
              <th>Acțiuni</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="factura in facturi" :key="factura.id">
              <tr :class="`row-factura-${factura.id}`">
                <td class="text-center">
                  <div class="form-check form-check-custom form-check-success form-check-solid d-inline-flex">
                    <input
                      class="form-check-input row-select"
                      type="checkbox"
                      :checked="isSelected(factura.id)"
                      @change="onToggleSelect(factura.id, $event)"
                    />
                  </div>
                </td>
                <td class="details-control text-center" style="cursor: pointer;" @click="toggleFacturaDetails(factura)">
                  <i class="fas fa-chevron-down" :class="{ 'rotate-up': expandedRows.includes(factura.id) }"></i>
                </td>
                <td>{{ formatDate(factura.data_doc) || '/' }}</td>
                <td :data-order="Number(factura.nr_doc) || 0">
                    {{ factura.sd_serie }}{{ factura.nr_doc }}
                </td>
                <td>{{ factura.c_denumire || '/' }}</td>
                <td class="text-end">{{ formatMoney(factura.iesiri_date_valoare) }}</td>
                <td class="text-end">{{ formatMoney(factura.iesiri_date_tva) }}</td>
                <td class="text-end">{{ formatMoney(factura.iesiri_date_total) }}</td>
                <td>
                  <div class="progress h-30px">
                    <div
                      class="progress-bar progress-bar-striped progress-bar-animated text-white fw-bold fs-6 py-2"
                      :class="{
                        'bg-danger': Number(factura.stare) === 0 || factura.stare === null || factura.stare === undefined,
                        'bg-warning': Number(factura.stare) === 1,
                        'bg-success': Number(factura.stare) === 2
                      }"
                      role="progressbar"
                      :style="{
                        width: (Number(factura.stare) === 0 || factura.stare === null || factura.stare === undefined) ? '100%' : (Number(factura.stare) === 1 ? '75%' : '100%')
                      }"
                      :aria-valuenow="(Number(factura.stare) === 0 || factura.stare === null || factura.stare === undefined) ? 100 : (Number(factura.stare) === 1 ? 75 : 100)"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      {{ (Number(factura.stare) === 0 || factura.stare === null || factura.stare === undefined) ? 'Restant' : (Number(factura.stare) === 1 ? 'Parțial' : 'Achitat') }}
                    </div>
                  </div>
                </td>
                <td class="text-end">{{ formatMoney(factura.isf_sold) }}</td>
                <td>{{ formatDate(factura.data_scadenta) || '/' }}</td>
                <td class="text-center">
                  <div class="form-check form-check-custom form-check-success form-check-solid d-inline-flex align-items-center mb-0">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :checked="!!factura.tva_incasare"
                      disabled
                    />
                  </div>
                </td>
                <td>
                  <div v-if="Number(factura.anaf_ft_status) === 1"
                       class="progress h-30px efact-clickable"
                       @click="showEFactPopup(factura, 'upload')">
                    <div
                      class="progress-bar progress-bar-striped progress-bar-animated text-white fw-bold fs-7 py-1"
                      :class="eFactUploadBarClass(factura.anaf_ft_stare_upload)"
                      role="progressbar"
                      :style="{ width: '100%' }"
                      :aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"
                    >
                      {{ eFactUploadBarLabel(factura.anaf_ft_stare_upload) }}
                    </div>
                  </div>
                  <div v-else class="progress h-30px efact-clickable" @click="showEFactPopup(factura, 'status')">
                    <div
                      class="progress-bar progress-bar-striped progress-bar-animated text-white fw-bold fs-7 py-1"
                      :class="eFactStatusBarClass(factura.anaf_ft_status)"
                      role="progressbar"
                      :style="{ width: '100%' }"
                      :aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"
                    >
                      {{ eFactStatusBarLabel(factura.anaf_ft_status) }}
                    </div>
                  </div>
                </td>
                <td>{{ factura.agent || '-' }}</td>
                <td class="text-center">
                  <span v-if="factura.rj_id" class="text-success" title="Înregistrare existentă">✅</span>
                  <span v-else class="text-danger" title="Fără înregistrare">❌</span>
                </td>
                <td class="text-center">
                  <button
                    type="button"
                    class="btn btn-icon btn-sm btn-light-primary"
                    @click.stop="openRJModal(factura)"
                    title="Registru jurnal"
                  >
                    <i class="fa-solid fa-book"></i>
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal/popup simplu pentru e-Fact (opțional, poți integra în modalul global al proiectului) -->
    <div v-if="efactPopup.visible" class="modal-backdrop" @click="efactPopup.visible=false">
      <div class="modal-card" @click.stop>
        <div class="modal-header">
          <h5 class="modal-title">{{ efactPopup.title }}</h5>
          <button type="button" class="btn-close" @click="efactPopup.visible=false">×</button>
        </div>
        <div class="modal-body" v-html="efactPopup.message"></div>
      </div>
    </div>

    <!-- Modal Registru Jurnal - Facturi emise (Bootstrap modal) -->
    <div class="modal fade" id="lucruModalFacturiEmise" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-xxl-custom modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Lucru pe factură</h5>
            <button type="button" class="btn-close" aria-label="Close" @click="closeRJModal"></button>
          </div>
          <div class="modal-body">
            <div v-if="rjLoading">
              <p>Se încarcă datele din registrul jurnal...</p>
            </div>
            <div v-else class="row g-4">
              <!-- LEFT: Detalii factură + Produse -->
              <div class="col-12 col-xl-6">
                <div v-if="modalFactura">
                  <div class="mb-4">
                    <div class="fs-6 text-muted mb-2">Detalii factură</div>
                    <div class="border rounded p-3 bg-light">
                      <div class="row mb-2">
                        <div class="col-5 text-muted">ID</div>
                        <div class="col-7">{{ modalFactura?.id ?? '-' }}</div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-5 text-muted">Serie / Nr.</div>
                        <div class="col-7">
                          {{ (modalFactura?.sd_serie || modalFactura?.serie_doc || '') + (modalFactura?.nr_doc || '') }}
                        </div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-5 text-muted">Data</div>
                        <div class="col-7">{{ formatDate(modalFactura?.data_doc) || '-' }}</div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-5 text-muted">Data eFactura</div>
                        <div class="col-7">{{ $filters.formatDate(modalFactura?.afp_data_creare) || '-' }}</div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-5 text-muted">Client</div>
                        <div class="col-7">{{ modalFactura?.c_denumire || '-' }}</div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-5 text-muted">Valoare / TVA / Total</div>
                        <div class="col-7">
                          {{ formatMoney(modalFactura?.iesiri_date_valoare) }} /
                          {{ formatMoney(modalFactura?.iesiri_date_tva) }} /
                          {{ formatMoney(modalFactura?.iesiri_date_total) }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div class="d-flex align-items-center mb-2">
                      <div class="fs-6 text-muted me-2">Produse</div>
                      <div v-if="modalLoading" class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>
                    <div class="modal-products-scroll border rounded">
                      <table class="table table-sm table-striped align-middle mb-0">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Denumire</th>
                            <th class="text-end">Cant.</th>
                            <th class="text-end">Preț</th>
                            <th class="text-end">Valoare</th>
                            <th class="text-end">TVA</th>
                            <th class="text-end">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="!modalLoading && (!modalProduse || modalProduse.length === 0)">
                            <td colspan="7" class="text-center text-muted py-4">
                              Nu există produse pentru această factură.
                            </td>
                          </tr>
                          <tr v-for="(p, idx) in modalProduse" :key="`p_${idx}`">
                            <td>{{ idx + 1 }}</td>
                            <td>{{ productName(p) }}</td>
                            <td class="text-end">{{ productQty(p) }}</td>
                            <td class="text-end">{{ productPrice(p) }}</td>
                            <td class="text-end">{{ productValue(p) }}</td>
                            <td class="text-end">{{ productTva(p) }}</td>
                            <td class="text-end">{{ productTotal(p) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div v-else class="text-muted">
                  Nu există detalii de factură de afișat.
                </div>
              </div>

              <!-- RIGHT: RJ form -->
              <div class="col-12 col-xl-6">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <div class="fs-6 text-muted">Înregistrare contabilă (RJ)</div>
                  <span v-if="rjExists" class="badge bg-success">Înregistrare existentă</span>
                  <span v-else class="badge bg-secondary">Nouă, nesalvată în RJ</span>
                </div>

                <form @submit.prevent="submitRJ" autocomplete="off">
                  <div v-if="rjErrors && rjErrors.length" class="alert alert-danger py-2">
                    <ul class="mb-0 ps-4">
                      <li v-for="(err, idx) in rjErrors" :key="`rj_err_${idx}`">{{ err }}</li>
                    </ul>
                  </div>

                  <div class="row g-3">
                    <div class="col-12">
                      <div class="form-check form-switch">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="switchAutoRJEmis"
                          v-model="useAutoRJ"
                        />
                        <label class="form-check-label" for="switchAutoRJEmis">
                          Postare automată (2 linii: 4111 → 707 &amp; 4427)
                        </label>
                      </div>
                    </div>

                    <div class="col-12 col-md-6">
                      <label class="form-label">Data document</label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="rjForm.data_doc"
                      />
                    </div>
                    <div class="col-12 col-md-6">
                      <label class="form-label">Observații</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="rjForm.observatii"
                        placeholder="Notițe interne"
                      />
                    </div>

                    <div class="col-12">
                      <label class="form-label">Client</label>
                      <input
                        type="text"
                        class="form-control"
                        :value="modalFactura?.c_denumire || '-'"
                        disabled
                      />
                    </div>

                    <div class="col-12 col-md-4">
                      <label class="form-label">Monedă</label>
                      <select class="form-select" v-model="rjForm.moneda">
                        <option value="RON">RON</option>
                        <option value="EUR">EUR</option>
                        <option value="USD">USD</option>
                      </select>
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">Curs</label>
                      <input
                        type="number"
                        step="0.0001"
                        class="form-control text-end"
                        v-model.number="rjForm.curs"
                        :readonly="rjForm.moneda === 'RON'"
                      />
                    </div>
                    <div class="col-12 col-md-2">
                      <label class="form-label">Serie</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="rjForm.serie_doc"
                        :placeholder="modalFactura?.sd_serie || ''"
                      />
                    </div>
                    <div class="col-12 col-md-2">
                      <label class="form-label">Nr.</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="rjForm.nr_doc"
                        :placeholder="modalFactura?.nr_doc || ''"
                      />
                    </div>

                    <div class="col-12 col-md-4">
                      <label class="form-label">Bază</label>
                      <input
                        type="number"
                        step="0.01"
                        class="form-control text-end"
                        v-model.number="rjForm.valoare_baza"
                      />
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">TVA</label>
                      <input
                        type="number"
                        step="0.01"
                        class="form-control text-end"
                        v-model.number="rjForm.valoare_tva"
                      />
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">Total</label>
                      <input
                        type="number"
                        step="0.01"
                        class="form-control text-end"
                        v-model.number="rjForm.valoare_total"
                      />
                    </div>

                    <!-- Previzualizare pentru modul AUTO -->
                    <div v-if="useAutoRJ" class="col-12">
                      <label class="form-label fw-bold">Linii contabile (AUTO — previzualizare)</label>
                      <table class="table table-sm table-bordered align-middle mb-1">
                        <thead>
                          <tr>
                            <th>Debit</th>
                            <th>Credit</th>
                            <th class="text-end">Sumă</th>
                            <th>Explicație</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="autoPreviewLines.length === 0">
                            <td colspan="4" class="text-center text-muted py-3">
                              Completează valorile pentru a vedea previzualizarea.
                            </td>
                          </tr>
                          <tr v-for="(r, i) in autoPreviewLines" :key="`auto_${i}`">
                            <td>{{ r.debit }}</td>
                            <td>{{ r.credit }}</td>
                            <td class="text-end">
                              {{ Number(r.suma).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                            </td>
                            <td>{{ r.explicatie }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <small class="text-muted">
                        * Previzualizare informativă — la salvare se vor posta liniile generate automat.
                      </small>
                    </div>

                    <!-- Repeater pentru modul MANUAL -->
                    <div v-if="!useAutoRJ" class="col-12">
                      <label class="form-label fw-bold">Linii contabile</label>
                      <table class="table table-sm table-bordered align-middle">
                        <thead>
                          <tr>
                            <th>Debit</th>
                            <th>Credit</th>
                            <th style="width:160px" class="text-end">Sumă</th>
                            <th>Explicație</th>
                            <th style="width:48px"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(linie, idx) in liniiRJ" :key="`rj_${idx}`">
                            <td>
                              <input
                                type="text"
                                class="form-control"
                                v-model="linie.cont_debit"
                                placeholder="ex: 4111.26"
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                class="form-control"
                                v-model="linie.cont_credit"
                                placeholder="ex: 707 sau 4427"
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                step="0.01"
                                class="form-control text-end"
                                v-model.number="linie.suma"
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                class="form-control"
                                v-model="linie.explicatie"
                                placeholder="Explicație"
                              />
                            </td>
                            <td class="text-center">
                              <button
                                type="button"
                                class="btn btn-sm btn-light-danger"
                                @click="liniiRJ.splice(idx, 1)"
                              >
                                <i class="fa-solid fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <button
                        type="button"
                        class="btn btn-light-primary btn-sm"
                        @click="liniiRJ.push({ cont_debit: '', cont_credit: '', suma: 0, explicatie: '' })"
                      >
                        <i class="fa-solid fa-plus"></i> Adaugă linie
                      </button>
                      <small class="text-muted ms-2">
                        Sfat: asigură-te că totalul debitelor = totalul creditelor.
                      </small>
                    </div>

                    <div class="col-12 d-flex justify-content-end gap-2">
                      <button type="button" class="btn btn-light" @click="resetRJ">
                        Reset
                      </button>
                      <button type="submit" class="btn btn-primary" :disabled="rjSaving">
                        <span
                          v-if="rjSaving"
                          class="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Salvează RJ
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" @click="closeRJModal">Închide</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createApp } from 'vue';
import axios from 'axios';
import FacturaChild from './Iesiri_FacturaChild.vue';

export default {
  name: 'FacturiEmise',
  props: {
    firmaId: { type: [Number, String], required: true }
  },
  data() {
    return {
      facturi: [],
      selectedRowIds: [],
      expandedRows: [],
      produseCache: {},     // { [facturaId]: rows[] }
      childApps: {},        // { [facturaId]: appInstance }
      dtInstance: null,     // DataTables instance (v1 sau v2)
      dtInitializing: false,
      efactPopup: { visible: false, title: '', message: '' },
      rjModalVisible: false,
      rjLoading: false,
      rjSaving: false,
      modalFactura: null,
      modalProduse: [],
      modalLoading: false,
      useAutoRJ: true,
      rjForm: {
        id_firma: null,
        id_document: null,
        tip_document: 'Factura',
        serie_doc: '',
        nr_doc: '',
        data_doc: '',
        moneda: 'RON',
        curs: 1,
        perioada_contabila: '',
        id_client: null,
        valoare_baza: 0,
        valoare_tva: 0,
        valoare_total: 0,
        observatii: '',
        cont_venit: '707',
        cont_tva: '4427',
      },
      liniiRJ: [],
      rjErrors: [],
      rjExists: false,
    };
  },
  computed: {
    selectAllVisibleChecked() {
      if (!Array.isArray(this.facturi) || this.facturi.length === 0) return false;
      const visibleIds = this.facturi.map(r => r.id);
      return visibleIds.every(id => this.selectedRowIds.includes(id));
    },
    autoPreviewLines() {
      if (!this.useAutoRJ || !this.modalFactura) return [];
      const baza = Number(this.rjForm.valoare_baza || this.modalFactura.iesiri_date_valoare || 0);
      const tva = Number(this.rjForm.valoare_tva || this.modalFactura.iesiri_date_tva || 0);
      const idClient = this.rjForm.id_client || this.modalFactura.id_client || null;
      const contClient = idClient ? `4111.${idClient}` : '4111';

      const lines = [];
      if (baza > 0) {
        lines.push({
          debit: contClient,
          credit: this.rjForm.cont_venit || '707',
          suma: baza,
          explicatie: 'Venit (bază)',
        });
      }
      if (tva > 0) {
        lines.push({
          debit: contClient,
          credit: this.rjForm.cont_tva || '4427',
          suma: tva,
          explicatie: 'TVA colectată (4427)',
        });
      }
      return lines;
    },
  },
  watch: {
    firmaId: {
      immediate: true,
      handler() {
        this.loadFacturi();
      }
    }
  },
  mounted() {},
  beforeUnmount() {
    this.destroyDT();
    // unmount orice child apps rămase
    Object.values(this.childApps).forEach(app => { try { app.unmount(); } catch {} });
    this.childApps = {};
  },
  methods: {
    // ===== Helpers =====
    ensureDTReady(cb, attempt = 0) {
      const MAX = 10;
      const $ = window.jQuery || window.$;
      const ready = ($ && $.fn && ($.fn.DataTable || $.fn.dataTable)) || (typeof window !== 'undefined' && window.DataTable);
      if (ready) { cb($); return; }
      if (attempt >= MAX) { console.warn('DataTables not available after wait'); return; }
      setTimeout(() => this.ensureDTReady(cb, attempt + 1), 50);
    },
    destroyDT() {
      if (this.dtInstance && typeof this.dtInstance.destroy === 'function') {
        try { this.dtInstance.destroy(); } catch {}
      }
      this.dtInstance = null;
    },
    formatDate(d) {
      if (!d) return '';
      try { return new Date(d).toLocaleDateString('ro-RO'); } catch { return ''; }
    },
    formatMoney(v) {
      const n = Number(v || 0);
      return n.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' lei';
    },
    isSelected(id) {
      return this.selectedRowIds.includes(id);
    },
    onToggleSelect(id, ev) {
      const checked = !!(ev && ev.target && ev.target.checked);
      const idx = this.selectedRowIds.indexOf(id);
      if (checked && idx === -1) this.selectedRowIds.push(id);
      if (!checked && idx !== -1) this.selectedRowIds.splice(idx, 1);
    },
    onToggleSelectAllVisible(ev) {
      const checked = !!(ev && ev.target && ev.target.checked);
      const visibleIds = (this.facturi || []).map(r => r.id);
      if (checked) {
        this.selectedRowIds = Array.from(new Set([...this.selectedRowIds, ...visibleIds]));
      } else {
        this.selectedRowIds = this.selectedRowIds.filter(id => !visibleIds.includes(id));
      }
    },
    // ===== Data loading =====
    async loadFacturi() {
      if (!this.firmaId) return;
      try {
        const res = await axios.get('/api/administrare/work/incarcaFacturiEmise', { params: { firma_id: this.firmaId } });
        this.facturi = Array.isArray(res.data) ? res.data : (res.data.facturi || []);

        $(document).ready(() => {
          const $tbl = $('#tabel_facturare');
          try { $tbl.DataTable().destroy(); } catch {}

          $.fn.dataTable.ext.type.order['date-eu-pre'] = function (date) {
            if (!date) return 0;
            const parts = date.split('.');
            return Date.parse(`${parts[2]}-${parts[1]}-${parts[0]}`); // YYYY-MM-DD
          };

          const vm = this;
          $tbl.DataTable({
            pageLength: 15,
            lengthChange: false,
            columnDefs: [
              { targets: 0, responsivePriority: 1 },
              { targets: 2, type: 'date-eu' } // coloana "Data"
            ],
            order: [[2, 'desc']], // sortează după "Data"
            buttons: ['disable'],
            language: { url: 'https://cdn.datatables.net/plug-ins/1.11.3/i18n/ro.json' },
            paging: true,
            ordering: true,
            info: true,
            searching: true,
            responsive: false,
            //scrollX: true,
            createdRow: function (row, data, dataIndex) {
              const factura = vm.facturi[dataIndex];
              if (factura && factura.id) {
                $(row).addClass(`row-factura-${factura.id}`);
              } else {
                console.warn('Factura ID not found for dataIndex:', dataIndex, data);
              }
            }
          });
          
          // Click-ul pe expandare este gestionat prin Vue (@click in template)
        });
      } catch (e) {
        console.error('Eroare la încărcarea facturilor emise:', e);
        this.facturi = [];
        $(document).ready(() => {
          const $tbl = $('#tabel_facturare');
          try { $tbl.DataTable().destroy(); } catch {}
          $tbl.DataTable({ responsive: false });
        });
      }
    },
    initDT() {
      // no-op: DataTable este inițializat direct în loadFacturi(), similar cu componenta Intrari
    },
    // ===== Child row =====
    async incarcaProduseFactura(id) {
      try {
        const response = await axios.get(`/api/administrare/work/incarcaFacturiEmise/${id}`);
        const data = Array.isArray(response.data)
          ? response.data
          : (response.data?.produse || response.data?.items || response.data?.rows || []);
        this.produseCache = { ...this.produseCache, [id]: data };
        return data;
      } catch (error) {
        console.error(`Eroare la încărcarea produselor pentru factura ${id}:`, error);
        this.produseCache = { ...this.produseCache, [id]: [] };
        return [];
      }
    },
    toggleFacturaDetails(factura) {
      const $ = window.jQuery || window.$;
      const table = $ && $.fn && $.fn.DataTable ? $('#tabel_facturare').DataTable() : null;
      if (!table) return;
      const tr = $(`.row-factura-${factura.id}`);
      const row = table.row(tr);

      if (row.child.isShown()) {
        row.child.hide();
        tr.removeClass('shown');
        this.expandedRows = this.expandedRows.filter(id => id !== factura.id);
        const inst = this.childApps[factura.id];
        if (inst && typeof inst.unmount === 'function') {
          try { inst.unmount(); } catch {}
        }
        delete this.childApps[factura.id];
        return;
      }

      const mountChild = (items) => {
        const wrapper = document.createElement('div');
        const app = createApp(FacturaChild, { factura, produse: items || [] });
        app.mount(wrapper);
        this.childApps[factura.id] = app;
        row.child(wrapper).show();
        tr.addClass('shown');
        if (!this.expandedRows.includes(factura.id)) this.expandedRows.push(factura.id);
      };

      row.child('<div class="p-3 text-muted">Se încarcă produsele...</div>').show();
      tr.addClass('shown');

      if (this.produseCache[factura.id]) {
        mountChild(this.produseCache[factura.id]);
      } else {
        this.incarcaProduseFactura(factura.id).then(() => {
          const items = this.produseCache[factura.id] || [];
          mountChild(items);
        });
      }
    },
    // ===== Registru Jurnal - Facturi emise =====
    prefillRJFormFromFactura(factura) {
      if (!factura) return;
      const baza = Number(factura.iesiri_date_valoare || 0);
      const tva = Number(factura.iesiri_date_tva || 0);
      const total = Number(factura.iesiri_date_total || (baza + tva));
      const idClient = factura.id_client || null;
      const contClient = idClient ? `4111.${idClient}` : '4111';

      const perioada =
        factura.data_doc && factura.data_doc.toString().length >= 7
          ? factura.data_doc.toString().slice(0, 7)
          : '';

      this.rjForm = {
        ...this.rjForm,
        id_firma: Number(this.firmaId) || null,
        id_document: factura.id,
        tip_document: 'Factura',
        serie_doc: factura.sd_serie || '',
        nr_doc: factura.nr_doc || '',
        data_doc: factura.data_doc || '',
        moneda: this.rjForm.moneda || 'RON',
        curs: this.rjForm.curs || 1,
        perioada_contabila: this.rjForm.perioada_contabila || perioada,
        id_client: idClient,
        valoare_baza: baza,
        valoare_tva: tva,
        valoare_total: total,
        observatii: this.rjForm.observatii || '',
        cont_venit: this.rjForm.cont_venit || '707',
        cont_tva: this.rjForm.cont_tva || '4427',
      };
      // Liniile manuale nu se prepopulează aici, se lasă goale
    },
    async openRJModal(factura) {
      this.rjExists = false;
      this.liniiRJ = [];
      this.modalFactura = factura || null;
      this.rjLoading = true;
      this.rjSaving = false;
      this.rjErrors = [];
      this.useAutoRJ = true;
      this.modalProduse = [];
      this.modalLoading = false;

      // deschidem modalul Bootstrap (ca la FacturiPrimite)
      const id = 'lucruModalFacturiEmise';
      if (window.bootstrap && window.bootstrap.Modal) {
        const modalEl = document.getElementById(id);
        if (modalEl) {
          const instance = window.bootstrap.Modal.getOrCreateInstance(modalEl);
          instance.show();
        }
      } else if (window.$ && window.$.fn && window.$.fn.modal) {
        window.$('#' + id).modal('show');
      }

      if (factura) {
        this.prefillRJFormFromFactura(factura);
        // încărcăm produsele pentru afișare în partea stângă (Produse)
        try {
          const items = await this.incarcaProduseFactura(factura.id);
          this.modalProduse = Array.isArray(items) ? items : [];
        } catch (e) {
          console.error('Eroare la încărcarea produselor pentru RJ factură emisă:', e);
          this.modalProduse = [];
        } finally {
          this.modalLoading = false;
        }
      }

      try {
        const res = await axios.get('/api/administrare/work/reg-jurnal/factura-emisa', {
          params: {
            firma_id: this.firmaId,
            document_id: factura.id,
            tip_document: 'Factura',
          },
        });

        if (res.data && res.data.exists) {
          this.rjExists = true;

          const antet = res.data.antet || {};
          this.rjForm = {
            ...this.rjForm,
            id_firma: antet.id_firma || Number(this.firmaId) || null,
            id_document: antet.id_document || factura.id,
            tip_document: antet.tip_document || 'Factura',
            serie_doc: antet.doc_serie || this.rjForm.serie_doc,
            nr_doc: antet.doc_numar || this.rjForm.nr_doc,
            data_doc: antet.doc_data || this.rjForm.data_doc,
            moneda: antet.moneda || this.rjForm.moneda,
            curs: antet.curs || this.rjForm.curs,
            perioada_contabila: antet.perioada_contabila || this.rjForm.perioada_contabila,
            valoare_baza:
              antet.valoare_baza !== undefined ? Number(antet.valoare_baza) : this.rjForm.valoare_baza,
            valoare_tva:
              antet.valoare_tva !== undefined ? Number(antet.valoare_tva) : this.rjForm.valoare_tva,
            valoare_total:
              antet.valoare_total !== undefined ? Number(antet.valoare_total) : this.rjForm.valoare_total,
            observatii: antet.observatii || this.rjForm.observatii,
          };

          const linii = Array.isArray(res.data.linii) ? res.data.linii : [];
          this.liniiRJ = linii.map(l => ({
            cont_debit: l.cont_debit || '',
            cont_credit: l.cont_credit || '',
            suma: Number(l.suma || 0),
            explicatie: l.explicatie || '',
          }));
          this.useAutoRJ = this.liniiRJ.length === 0;
        } else {
          this.rjExists = false;
          this.useAutoRJ = true;
          this.liniiRJ = [];
        }
      } catch (e) {
        console.error('Eroare la încărcarea RJ pentru factura emisă:', e);
        this.rjErrors.push('A apărut o eroare la încărcarea datelor din registru jurnal.');
        this.useAutoRJ = true;
        this.rjExists = false;
      } finally {
        this.rjLoading = false;
      }
    },
    closeRJModal() {
      // închidem modalul Bootstrap
      const id = 'lucruModalFacturiEmise';
      if (window.bootstrap && window.bootstrap.Modal) {
        const modalEl = document.getElementById(id);
        if (modalEl) {
          const instance = window.bootstrap.Modal.getInstance(modalEl);
          if (instance) instance.hide();
        }
      } else if (window.$ && window.$.fn && window.$.fn.modal) {
        window.$('#' + id).modal('hide');
      }

      // resetăm state-ul local
      this.rjModalVisible = false;
      this.modalFactura = null;
      this.rjExists = false;
      this.liniiRJ = [];
      this.rjErrors = [];
      this.rjLoading = false;
      this.rjSaving = false;
      this.modalProduse = [];
      this.modalLoading = false;
    },
    // ===== Helpers produse pentru modal RJ =====
    productName(p) {
      if (!p) return '-';
      return (
        p.denumire ||
        p.p_denumire ||
        p.produs_denumire ||
        p.nume_produs ||
        '-'
      );
    },
    productQty(p) {
      if (!p) return '';
      const q = p.cantitate ?? p.cant ?? p.qty ?? p.cant_fact ?? 0;
      return Number(q || 0).toLocaleString('ro-RO', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    productPrice(p) {
      if (!p) return '';
      const v = p.pret ?? p.pret_unitar ?? p.pu ?? p.pret_vanzare ?? 0;
      return this.formatMoney(v);
    },
    productValue(p) {
      if (!p) return '';
      const v =
        p.valoare ??
        p.valoare_fara_tva ??
        p.total_fara_tva ??
        p.suma_fara_tva ??
        0;
      return this.formatMoney(v);
    },
    productTva(p) {
      if (!p) return '';
      const v = p.tva ?? p.valoare_tva ?? p.suma_tva ?? 0;
      return this.formatMoney(v);
    },
    productTotal(p) {
      if (!p) return '';
      const v =
        p.total ??
        p.total_cu_tva ??
        p.valoare_cu_tva ??
        (p.valoare || 0) + (p.tva || 0);
      return this.formatMoney(v);
    },
    resetRJ() {
      this.rjErrors = [];
      if (this.modalFactura) {
        this.prefillRJFormFromFactura(this.modalFactura);
      } else {
        this.rjForm.valoare_baza = 0;
        this.rjForm.valoare_tva = 0;
        this.rjForm.valoare_total = 0;
        this.liniiRJ = [];
      }
    },
    async submitRJ() {
      if (!this.modalFactura) return;
      this.rjErrors = [];
      const errs = [];

      if (!this.useAutoRJ) {
        if (!Array.isArray(this.liniiRJ) || this.liniiRJ.length === 0) {
          errs.push('Adaugă cel puțin o linie contabilă.');
        } else {
          const invalid = this.liniiRJ.find(
            l => !l || !(Number(l.suma) > 0) || (!l.cont_debit && !l.cont_credit),
          );
          if (invalid) {
            errs.push(
              'Toate liniile trebuie să aibă cel puțin un cont (debit sau credit) și o sumă > 0.',
            );
          }
          const sumD = this.liniiRJ.reduce(
            (a, l) => a + (l.cont_debit ? Number(l.suma) || 0 : 0),
            0,
          );
          const sumC = this.liniiRJ.reduce(
            (a, l) => a + (l.cont_credit ? Number(l.suma) || 0 : 0),
            0,
          );
          if (+sumD.toFixed(2) !== +sumC.toFixed(2)) {
            errs.push(`Balanța liniilor nu este egală (D ${sumD.toFixed(2)} ≠ C ${sumC.toFixed(2)}).`);
          }

          const tvaFromLines = this.liniiRJ
            .filter(
              l =>
                typeof l.cont_credit === 'string' &&
                l.cont_credit.trim().startsWith('4427'),
            )
            .reduce((a, l) => a + (Number(l.suma) || 0), 0);
          const sumCredit = this.liniiRJ.reduce(
            (a, l) => a + (l.cont_credit ? Number(l.suma) || 0 : 0),
            0,
          );
          const bazaFromLines = sumCredit - tvaFromLines;
          const totalFromLines = sumCredit;

          this.rjForm.valoare_baza = bazaFromLines;
          this.rjForm.valoare_tva = tvaFromLines;
          this.rjForm.valoare_total = totalFromLines;
        }
      } else {
        const baza =
          this.rjForm.valoare_baza ||
          this.modalFactura.iesiri_date_valoare ||
          0;
        const tva =
          this.rjForm.valoare_tva ||
          this.modalFactura.iesiri_date_tva ||
          0;
        const tot =
          this.rjForm.valoare_total ||
          this.modalFactura.iesiri_date_total ||
          baza + tva;

        this.rjForm.valoare_baza = Number(baza);
        this.rjForm.valoare_tva = Number(tva);
        this.rjForm.valoare_total = Number(tot);

        if (!this.rjForm.id_client && !this.modalFactura.id_client) {
          errs.push('Nu există client asociat facturii (id_client). Nu se poate posta automat.');
        }
      }

      if (errs.length) {
        this.rjErrors = errs;
        return;
      }

      const antetPayload = {
        id_firma: Number(this.firmaId),
        id_document: this.modalFactura.id,
        tip_document: this.rjForm.tip_document || 'Factura',
        serie_doc: this.rjForm.serie_doc || this.modalFactura.sd_serie || '',
        nr_doc: this.rjForm.nr_doc || this.modalFactura.nr_doc || '',
        data_doc: this.rjForm.data_doc || this.modalFactura.data_doc || '',
        moneda: this.rjForm.moneda || 'RON',
        curs: this.rjForm.curs || 1,
        perioada_contabila:
          this.rjForm.perioada_contabila ||
          (this.modalFactura.data_doc
            ? this.modalFactura.data_doc.toString().slice(0, 7)
            : ''),
        id_client: this.rjForm.id_client || this.modalFactura.id_client || null,
        valoare_baza: Number(this.rjForm.valoare_baza || 0),
        valoare_tva: Number(this.rjForm.valoare_tva || 0),
        valoare_total: Number(this.rjForm.valoare_total || 0),
        observatii: this.rjForm.observatii || '',
        cont_venit: this.rjForm.cont_venit || '707',
        cont_tva: this.rjForm.cont_tva || '4427',
      };

      const payload = {
        auto: this.useAutoRJ,
        antet: antetPayload,
      };

      if (!this.useAutoRJ) {
        payload.linii = this.liniiRJ
          .filter(
            l => l && Number(l.suma) > 0 && (l.cont_debit || l.cont_credit),
          )
          .map(l => ({
            cont_debit: l.cont_debit ? String(l.cont_debit).trim() : null,
            cont_credit: l.cont_credit ? String(l.cont_credit).trim() : null,
            suma: Number(l.suma),
            explicatie: l.explicatie ? String(l.explicatie).trim() : '',
          }));
      }

      this.rjSaving = true;
      try {
        const resp = await axios.post(
          '/api/administrare/work/reg-jurnal/factura-emisa/save',
          payload,
        );
        console.log('RJ factură emisă salvat:', resp.data);
        this.closeRJModal();
      } catch (e) {
        console.error('Eroare la salvarea RJ pentru factura emisă:', e);
        const msg =
          (e.response && e.response.data && e.response.data.error) ||
          'A apărut o eroare la salvare.';
        this.rjErrors = [msg];
      } finally {
        this.rjSaving = false;
      }
    },
    // ===== e-Fact popup helpers =====
    buildObsPrettyHtml(str) {
      const txt = (str || '').toString();
      const escaped = txt.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      return `<pre class="mb-0" style="white-space:pre-wrap">${escaped}</pre>`;
    },
    showEFactPopup(factura, tip) {
      try {
        const statusLabel = this.eFactStatusBarLabel(factura.anaf_ft_status);
        const uploadLabel = this.eFactUploadBarLabel(factura.anaf_ft_stare_upload);
        const obsStatusRaw = (factura.anaf_ft_obs || '').toString().trim();
        const obsUploadRaw = (factura.anaf_ft_obs_upload || '').toString().trim();

        let title = 'Detalii e-Factura';
        let message = '';

        if (tip === 'upload') {
          title = `Upload e-Factură — ${uploadLabel}`;
          message = obsUploadRaw ? this.buildObsPrettyHtml(obsUploadRaw) : '<p>Nu există observații pentru upload.</p>';
        } else {
          title = `Status e-Factură — ${statusLabel}`;
          if (obsStatusRaw) {
            message = this.buildObsPrettyHtml(obsStatusRaw);
          } else {
            switch (Number(factura.anaf_ft_status)) {
              case 1: message = '<p>Factura este marcată ca <strong>Transmisă</strong> către e-Factura.</p>'; break;
              case 2: message = '<p><strong>Eroare la trimitere.</strong> Puteți reîncerca.</p>'; break;
              case 3: message = '<p><strong>Eroare de validare XML.</strong> Corectați și reîncercați.</p>'; break;
              default: message = '<p>Factura nu a fost transmisă către e-Factura.</p>'; break;
            }
          }
        }

        this.efactPopup.title = title;
        this.efactPopup.message = message;
        this.efactPopup.visible = true;
      } catch (e) {
        console.error('showEFactPopup error:', e);
        this.efactPopup.title = 'Detalii e-Factura';
        this.efactPopup.message = 'A apărut o eroare la afișarea mesajului.';
        this.efactPopup.visible = true;
      }
    },
    eFactUploadBarLabel(code) {
      switch (Number(code)) {
        case 1: return 'Finalizat';
        case 2: return 'NOK';
        case 3: return 'Prelucrare';
        default: return 'Incarcata';
      }
    },
    eFactUploadBarClass(code) {
      switch (Number(code)) {
        case 1: return 'bg-success';
        case 2: return 'bg-danger';
        case 3: return 'bg-primary';
        default: return 'bg-info';
      }
    },
    eFactStatusBarLabel(code) {
      switch (Number(code)) {
        case 1: return 'Transmis';
        case 2: return 'Eroare trimitere';
        case 3: return 'Eroare XML';
        default: return 'Netransmis';
      }
    },
    eFactStatusBarClass(code) {
      switch (Number(code)) {
        case 1: return 'bg-primary';
        case 2: return 'bg-danger';
        case 3: return 'bg-warning';
        default: return 'bg-secondary';
      }
    },
  }
};
</script>

<style scoped>
/* full width table */
#tabel_facturare { width: 100% !important; }

/* basic modal, adaptă la tema ta */
.modal-backdrop {
  position: fixed; inset: 0; background: rgba(0,0,0,.35);
  display: flex; align-items: center; justify-content: center; z-index: 9999;
}
.modal-card {
  background: #fff;
  border-radius: 10px;
  width: min(1100px, 96vw); /* aliniat ca dimensiune cu modalul de la facturi primite */
  max-height: 90vh;
  overflow: auto;
}
.modal-header { display:flex; align-items:center; justify-content:space-between; padding: 14px 16px; border-bottom: 1px solid rgba(0,0,0,.06); }
.modal-body { padding: 16px; }
.btn-close { border:0; background:transparent; font-size: 22px; line-height: 1; cursor: pointer; }


.modal-products-scroll {
  max-height: 260px;
  overflow-y: auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.modal-products-scroll table {
  min-width: 900px; /* sau ajustează la nevoie, dar asigură overflow pe orizontală */
}

#lucruModalFacturiEmise .modal-dialog.modal-xxl-custom {
  max-width: 95vw;
  width: 95vw;
}


</style>